import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mini',
  templateUrl: './mini.component.html',
  styleUrls: ['./mini.component.scss']
})
export class MiniComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
